module.exports = __webpack_public_path__ + "img/placeInfo_bg.8ea298f3.png";